import * as Types from '../../../util/graphql/api.graphql';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';

export const GetDiagnosticReportDocument = gql`
  query GetDiagnosticReport($id: String!) {
    diagnosticReport(id: $id) {
      __typename
      code {
        coding {
          system
          code
        }
      }
      subject {
        reference
      }
      effectiveDateTime
      id
      status
      result {
        reference
      }
      extension {
        url
        valueReference {
          reference
        }
      }
    }
  }
`;

/**
 * __useGetDiagnosticReportQuery__
 *
 * To run a query within a React component, call `useGetDiagnosticReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiagnosticReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiagnosticReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDiagnosticReportQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetDiagnosticReportQueryResponse,
    GetDiagnosticReportQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    GetDiagnosticReportQueryResponse,
    GetDiagnosticReportQueryVariables
  >(GetDiagnosticReportDocument, baseOptions);
}
export function useGetDiagnosticReportLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetDiagnosticReportQueryResponse,
    GetDiagnosticReportQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    GetDiagnosticReportQueryResponse,
    GetDiagnosticReportQueryVariables
  >(GetDiagnosticReportDocument, baseOptions);
}
export type GetDiagnosticReportQueryHookResult = ReturnType<
  typeof useGetDiagnosticReportQuery
>;
export type GetDiagnosticReportLazyQueryHookResult = ReturnType<
  typeof useGetDiagnosticReportLazyQuery
>;
export type GetDiagnosticReportQueryResult = ApolloReactCommon.QueryResult<
  GetDiagnosticReportQueryResponse,
  GetDiagnosticReportQueryVariables
>;
export type GetDiagnosticReportQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;

export type GetDiagnosticReportQueryResponse = {
  __typename: 'Query';
  diagnosticReport?: Types.Maybe<{
    __typename: 'DiagnosticReport';
    effectiveDateTime?: Types.Maybe<string>;
    id?: Types.Maybe<string>;
    status: Types.DiagnosticReportStatus;
    code: {
      __typename: 'CodeableConcept';
      coding?: Types.Maybe<
        Array<{
          __typename: 'Coding';
          system?: Types.Maybe<string>;
          code?: Types.Maybe<string>;
        }>
      >;
    };
    subject?: Types.Maybe<{
      __typename: 'Reference';
      reference?: Types.Maybe<string>;
    }>;
    result?: Types.Maybe<
      Array<{ __typename: 'Reference'; reference?: Types.Maybe<string> }>
    >;
    extension?: Types.Maybe<
      Array<{
        __typename: 'Extension';
        url?: Types.Maybe<string>;
        valueReference?: Types.Maybe<{
          __typename: 'Reference';
          reference?: Types.Maybe<string>;
        }>;
      }>
    >;
  }>;
};
